export default __webpack_public_path__ + "static/media/dashboard-4.677a4986.png";